module.exports = __webpack_public_path__ + "assets/badge-module-3.4a65f7bd5afb09ce4451a74a54a01b38.svg";